import { FILTER_VERSION, getDefaultFilters } from '@/common/filterLogic'

const STORAGE_FILTER_KEY_DEFAULT = 'productFilters'
const STORAGE_SORT_KEY_DEFAULT = 'productSort'

const versionKey = key => `${key}-v`

// Bump FILTER_VERSION whenever the default filter shape changes — stale stored
// filters from an older version are discarded instead of migrated by hand.
function loadFiltersFromStorage (key) {
  try {
    if (Number(localStorage.getItem(versionKey(key))) !== FILTER_VERSION) {
      return getDefaultFilters()
    }
    const data = JSON.parse(localStorage.getItem(key))
    if (data && (!Array.isArray(data.judgmentStatus) || !Array.isArray(data.stockStatus))) {
      return getDefaultFilters()
    }
    return data || getDefaultFilters()
  } catch (e) {
    return getDefaultFilters()
  }
}

function persistFilters (state, storageKey) {
  localStorage.setItem(storageKey, JSON.stringify(state.saveFilters))
  localStorage.setItem(versionKey(storageKey), String(FILTER_VERSION))
}

function loadSortFromStorage (key) {
  try {
    const data = JSON.parse(localStorage.getItem(key))
    return data || 'parentAsin_asc'
  } catch (e) {
    return 'parentAsin_asc'
  }
}

const state = {
  saveFilters: getDefaultFilters(),
  saveSort: 'parentAsin_asc'
}

const mutations = {
  loadProductFilters (state, { storageKey = STORAGE_FILTER_KEY_DEFAULT } = {}) {
    state.saveFilters = loadFiltersFromStorage(storageKey)
    persistFilters(state, storageKey)
  },
  resetProductFilters (state, { storageKey = STORAGE_FILTER_KEY_DEFAULT } = {}) {
    state.saveFilters = getDefaultFilters()
    persistFilters(state, storageKey)
  },
  saveProductFilters (state, { data = {}, storageKey = STORAGE_FILTER_KEY_DEFAULT } = {}) {
    state.saveFilters = {
      ...state.saveFilters,
      ...data
    }
    persistFilters(state, storageKey)
  },
  loadProductSort (state, { storageKey = STORAGE_SORT_KEY_DEFAULT } = {}) {
    state.saveSort = loadSortFromStorage(storageKey)
  },
  saveProductSort (state, { saveSort = '', storageKey = STORAGE_SORT_KEY_DEFAULT } = {}) {
    state.saveSort = saveSort
    localStorage.setItem(storageKey, JSON.stringify(state.saveSort))
  }
}

const getters = {
  getProductFilters: state => state.saveFilters,
  getProductSort: state => state.saveSort
}

export default {
  state,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/products.js